import { TableHeader } from './table-header';
import { Row } from './fila';
import { Paginado } from './paginado';

export class Table{
    id:number;
    titulo: string;
    filas:Row[];
    tableHeader: TableHeader;
    paginado:Paginado;
    orderByIndex: number;
    order: boolean; //true = desc, false = asc
    columnas: string[];


    constructor(id,titulo,filas, columnas){
        this.titulo = titulo;
        this.tableHeader = new TableHeader();
        this.filas = filas;
        this.paginado = new Paginado(filas.length);
        this.columnas = columnas;
        this.id= id;
    }

    orderBy(index: number) {
        if (this.orderByIndex != index) {
            this.order = true;
            this.orderByIndex = index;
        }
        else {
            this.order = !this.order;
        }
        if (this.order) {
            this.filas = this.filas.sort((n1, n2) => {
                if (+n1.valores[index] === +n1.valores[index] && +n2.valores[index] === +n2.valores[index]) {
                    return Number(n1.valores[index]) - Number(n2.valores[index])
                }
                else {
                    if (n1.valores[index] > n2.valores[index]) {
                        return 1;
                    }

                    if (n1.valores[index] < n2.valores[index]) {
                        return -1;
                    }
                }
                return 0;
            });
        }
        else {
            this.filas = this.filas.sort((n1, n2) => {
                if (+n1.valores[index] === +n1.valores[index] && +n2.valores[index] === +n2.valores[index]) {
                    return Number(n2.valores[index]) - Number(n1.valores[index]) 
                }
                else {
                    if (n1.valores[index] < n2.valores[index]) {
                        return 1;
                    }

                    if (n1.valores[index] > n2.valores[index]) {
                        return -1;
                    }
                }
                return 0;
            });
        }

    }

}